import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getTradingPlatform = async (userId: string, categoryId: string, id: string) => {
  const { data, error } = await supabase
    .from('trading_platforms_users')
    .select('*')
    .eq('user_id', userId)
    .eq('category_id', categoryId)

  const { data: exceptions } = await supabase
    .from('trading_platforms_assets_exceptions')
    .select('*')
    .eq('asset_id', id)

  const exceptionsIds = exceptions?.map((e) => e.trading_platform)

  const platformId = data?.[0]?.trading_platform_id

  if (exceptionsIds?.includes(platformId)) {
    return null
  }

  if (error) {
    throw new Error(error.message)
  }

  return data?.length ? data[0] : null
}

export default function useHasTradingPlatform(userId: string, categoryId: string, id: string) {
  return useQuery({
    queryKey: ['useHasTradingPlatform', categoryId],
    queryFn: () => getTradingPlatform(userId, categoryId, id),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!userId && !!categoryId,
  })
}
